import React, { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

import { SvgIcons } from "../../common/SvgIcons";

import CalendraIconGray from "assets/images/calendra-icon.svg";
import LoadingGif from "assets/images/loading.gif";
import InfiniteScroll from "react-infinite-scroll-component";

import moment from "moment";
import ImageTag from "components/common/ImageTag";
import { datetimeFormats } from "constants/constants";
import { CUSTOMER } from "constants/roles";
import { getNotificationList } from "services/authService";
import storage from "helpers/storage";
import { nameBasedProtectedRoutes } from "router/protected";
import { getEncodedValue } from "helpers/common";

const LIMIT = 10;

function Notification(props) {
  const [items, setItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const navigate = useNavigate();

  const userInformation: {
    id: number;
    role: string;
  } = storage.getData("user-info");
  const userId = userInformation.id;
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    refreshFunction();
  }, [props.notificationCount]);

  // Fetch the notification list
  const fetchData = () => {
    getNotificationList({
      page: activePage,
      limit: LIMIT,
      id: userId,
    })
      .then((response) => {
        setActivePage(activePage + 1);
        setItems([...items, ...response?.data?.notification]);
        setTotalItems(response?.data?.total);
      })
      .catch((error) => {});
  };

  // Refresh the list on pull down the notification
  const refreshFunction = () => {
    getNotificationList({
      page: 1,
      limit: LIMIT,
      id: userId,
    })
      .then((response) => {
        setActivePage(2);
        setItems([...response?.data?.notification]);
        setTotalItems(response?.data?.total);
      })
      .catch((error) => {});
  };

  // function for navigate to SR detail page
  const srviewPage = (id) => {
    if (userInformation.role == CUSTOMER) {
      navigate(nameBasedProtectedRoutes.inspectionDetail.path + "/" + id);
    } else {
      navigate(
        nameBasedProtectedRoutes.iInspectionDetail.path +
          "/" +
          getEncodedValue(id)
      );
    }
  };

  return (
    <>
      <InfiniteScroll
        dataLength={items.length} //This is important field to render the next data
        next={fetchData}
        hasMore={items.length < totalItems}
        scrollableTarget="scrollableDiv"
        loader={
          <p style={{ textAlign: "center" }}>
            <ImageTag className="loading-icon w-24" src={LoadingGif} />
          </p>
        }
        endMessage={
          items.length > 0 ? (
            <Dropdown.Item>
              <p style={{ textAlign: "center" }}>Yay! You have seen it all</p>
            </Dropdown.Item>
          ) : (
            ""
          )
        }
        // Commented code is for client feedback if it approved than uncomment it otherwise will be remove
        // pullDownToRefresh={true}
        // // below props only if you need pull down functionality
        // refreshFunction={refreshFunction}
        // // pullDownToRefresh
        // pullDownToRefreshThreshold={50}
        // pullDownToRefreshContent={
        //   <p style={{ textAlign: "center" }}>&#8595; Pull down to refresh</p>
        // }
        // releaseToRefreshContent={
        //   <p style={{ textAlign: "center" }}>&#8593; Release to refresh</p>
        // }
      >
      
        {items && items.length > 0 ? (
          items.map((item) => (
            <Dropdown.Item>
              <div
                className="notification-box-item"
                onClick={() => srviewPage(item.inspection_id)}
              >
                <div className="fs-13 fw-semibold gray-color">
                  <ImageTag className="calendra-icon" src={CalendraIconGray} />
                  {item.created_at
                    ? moment(item.created_at).format(
                        datetimeFormats.separatedDate
                      )
                    : ""}{" "}
                </div>
                <div className="fs-15 fw-bold text-333">{item.description}</div>
                <div className="fs-15 fw-bold link-color">{item.title}</div>
              </div>
            </Dropdown.Item>
          ))
        ) : (<Dropdown.Item>No Notification</Dropdown.Item>)
        // props.isNotificationCount ? (
        //   <p style={{ textAlign: "center" }}>
        //     <ImageTag className="loading-icon w-24" src={LoadingGif} />
        //   </p>
        // ) : (
        //   <Dropdown.Item>No Notification</Dropdown.Item>
        // )
        }
      </InfiniteScroll>
    </>
  );
}

export default Notification;
